import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthComponent } from './login/auth/auth.component';

export const routes: Routes = [
  {
    path: 'login', component: LoginComponent
  },
  { path: 'auth', component: AuthComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],  // Export RouterModule to make routes available in other modules
})
export class AppRoutingModule {}
